(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-lookbok"] && !Shopify.designMode) return;
  try {
    
  window.initAllEmblaCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML; 

          // 1. Re-initialize the Carousel for the new content
          if (typeof window.initAllEmblaCarousels === 'function') {
              window.initAllEmblaCarousels();   
          }

          // 2. Re-initialize dropdowns on the newly inserted content
          if (typeof window.initDropdowns === 'function') {
              window.initDropdowns(); 
          }
        }        
      })
      .catch((e) => {
        console.error("Error fetching product recommendations:", e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection && productRecommendationsSection.innerHTML.trim().length === 0) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
